<template>
  <a-layout class='index animated fadeIn'>
  
    <a-card :bordered='false'>
      
    <SmallSquare :content='content' :padding='false'></SmallSquare>
 
      <a-form ref='form' class="m-t-20" :model='search' :style="{'marginBottom':'25px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
        <a-form-item label="" name='keywords'>
          <a-input-group compact :style="{width:'360px'}">
            <a-select v-model:value="search.type" style="width: 35%" @change="inputSelect">
              <a-select-option value="dealer_name">经销商名称</a-select-option>
              <a-select-option value="dealer_sn">经销商编号</a-select-option>
              <a-select-option value="leader_name">负责人</a-select-option>
              <a-select-option value="leader_phone">手机号</a-select-option>
            </a-select>
            <a-input style="width: 65%" v-model:value="search.keyword"  placeholder="请输入关键词进行搜索"/>
          </a-input-group>
        </a-form-item>
        <a-form-item label="经销商级别" name='level_id'>
          <a-select v-model:value="search.level_id" :style="{width:'140px'}" placeholder="全部">
            <a-select-option value="">全部</a-select-option>
            <a-select-option v-for='item in levelList' :key='item.level_id' :value="item.level_id">{{item.level_name}}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="状态" name='is_examine'>
          <a-select v-model:value="search.is_examine" :style="{width:'140px'}" placeholder="全部">
            <a-select-option value="">全部</a-select-option>
            <a-select-option :value="0">待审核</a-select-option>
            <!-- <a-select-option :value="1">审核通过</a-select-option> -->
            <a-select-option :value="2">审核不通过</a-select-option>
          </a-select>
        </a-form-item>
   
        <a-form-item label="创建日期" name='time'>
          <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit'>搜索</a-button>
        </a-form-item>
      </a-form>
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='dealer_id'  :columns='columns' :data-source='data' class="tableFixBox" :scroll="{ x: 'max-content'}">
        <template v-slot:is_examine="{ record }">
          <p v-if='record.is_examine == 0'>待审核</p>
          <p v-if='record.is_examine == 2'>审核不通过</p>
        </template>
        <template v-slot:action="{ record }">
            <a href="javascript:;" v-has:dealerReviewMore="()=> {$router.push('/customer/dealer/dealer_reviewMore?id='+record.dealer_id)}">查看申请</a>
        </template>
      </a-table>
      <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
    </a-card>
  </a-layout>
</template>
<script>
import { ref, onMounted,inject,reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { getRouter } from "@/utils/app";
import { setPageState, getPageState } from "@/utils/pageState";
import { getDealerReviewList,getDealerLevelList,getSaleCat } from "@/api/dealer";
import { iscode } from "@/utils/app";
// 初始化默认筛选项数值
let defSearch = {
  keyword: "",
  type:'dealer_name',
  page: 1,
  limit: 10,
  start_time:'',
  end_time:'',
  status:'',
  sale_cat_id:""
};
export default {
  components: {},
  setup(props, ctx) {
    // // 初始化 分页信息和筛选项信息
    let search = ref({ ...defSearch });
    // 列表数据和列头配置
    let data = ref([]);
    const state = reactive({
      levelList:[],
      listLoading: false,
      time:[],
      total: 1,
      content:'通过邀请方式的经销商注册，需要经过审核后才能正式启用'
    });
    let columns = [
      {
        title: "经销商编号",
        dataIndex: "dealer_sn",
        key: "dealer_sn",
      },
      {
        title: "经销商级别",
        dataIndex: "level_name",
        key: "level_name",
      },
      {
        title: "经销商名称",
        dataIndex: "dealer_name",
        key: "dealer_name",
      },
      {
        title: "手机号码",
        dataIndex: "leader_phone",
        key: "leader_phone",
      },
      {
        title: "负责人",
        dataIndex: "leader_name",
        key: "leader_name",
      },
      {
        title: "上级经销商",
        dataIndex: "parent_dealer_name",
        key: "parent_dealer_name",
      },
      {
        title: "状态",
        key: "is_examine",
        slots: { customRender: "is_examine" },
      },
      {
        title: "创建日期",
        dataIndex: "create_time",
        key: "create_time",
      },
      {
        title: "操作",
        key: "action",
        fixed: "right",
        slots: { customRender: "action" },
      },
    ];
    const $router = inject('$router')
    const $Modal = inject('$Modal')

    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    // 时间筛选
    const onChange = (e) => {
      search.value.start_time = e[0]
      search.value.end_time = e[1]
      initData(search.value);
    }
    // 获取经销商等级
    const getLevel = async() =>{
      let res = await getDealerLevelList().then(res => res.data);
      if (iscode(res)) {
        state.levelList = res.data;
      } else {
        message.error(res.msg);
      }
    }
    const initData = async (values) => {
      state.listLoading = true;
      try {
        let res = await getDealerReviewList(values).then(res=>res.data);
        state.listLoading = false;
        if (iscode(res)) {
          data.value = res.data.list;
          state.total = res.data.total;
        } else {
          message.error(res.msg);
        }
      } catch (e) {
        state.listLoading = false;
      }
    };
    const inputSelect = (e) =>{
      search.value.keyword = ''
    }

    onMounted(() => {
      // 查看是否有留存状态，有则替换
      let pageState = getPageState(getRouter().route.path);
      if (pageState) {
        search.value = Object.assign(search.value, pageState);
      }
      getLevel();
      initData(search.value);
    });
  
    return {
      ...toRefs(state),
      search,
      data,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      onChange,
      inputSelect
    };
  },
};
</script>